/**
 * Met à jour la config globale de l'appli
 * @type {string}
 */
export const SET_CONFIG = 'setConfig'
